import React from 'react'
import {withToggles, withDialogError} from 'startlibs/lib/hocs'
import {TextInput, Field, Form, SimpleRadiobox, IconRadioBox, Combobox, Errors, withForm} from 'startlibs/lib/form'
import {Dialog, Button, SplitColumnsContainer} from 'startlibs/lib/components'
import {ImageUpload} from '../../components/imageUpload'
import {ReportHeaderView} from '../viewer/ReportHeaderView'

const stringifyPaperSize = (e1)=>e1.join('-')

@withToggles('dialog')
export class Header extends React.Component {

  render() {
    const {reportSettings, dialog, uploadFetcher, action, getResource, isEmbedded} = this.props
    const {organization, layout} = reportSettings
    return (
      <div className={'report-header ' + layout.headerLayout}>
        <a className="edit-button" onClick={dialog.open}><span className="icon icon-edit-box"/>
          <span>Edit settings</span></a>
        {dialog.isOpen &&
        <ReportHeaderDialog
          getResource={getResource}
          formProperties={reportSettings}
          closeDialog={dialog.close}
          action={action}
          isEmbedded={isEmbedded}
          uploadFetcher={uploadFetcher}
        />}
        <ReportHeaderView getResource={getResource} organization={organization}/>
      </div>
    )
  }
}


const languageOptions = {'en_US': 'USA English', 'es': 'Spanish (soon)'}
const dateFormatOptions = {
  'LL dd, yyyy': 'Month Day, Year',
  'yyyy, LL dd': 'Year, Month Day',
  'dd, LL, yyyy': 'Day, Month, Year'
}

@withDialogError
@withToggles('organizationTab')
@withForm()
class ReportHeaderDialog extends React.Component {
  render() {
    const {closeDialog, children, form, organizationTab, uploadFetcher, getResource, isEmbedded} = this.props
    return (
      <Dialog
        closeDialog={closeDialog}
        title="General report settings"
        form={form}
        className='general-settings-dialog'
      >
        <div className="tabs-menu">
          <a className={organizationTab.isOpen ? 'active' : ''} onClick={organizationTab.open}>Institution info</a>
          <a className={!organizationTab.isOpen ? 'active' : ''} onClick={organizationTab.close}>Layout preferences</a>
        </div>
        {!organizationTab.isOpen ? <Dialog.Content>
            <Field label="Report header layout:" margin="big">
              <SplitColumnsContainer margin="small">
                <IconRadioBox
                  tabIndex={1}
                  form={form}
                  path={["layout","headerLayout"]}
                  label="Logo to the left and info to the right"
                  fieldValue="left-aligned-logo"
                  icon="hlogo-left"
                />
                <IconRadioBox
                  tabIndex={1}
                  form={form}
                  path={["layout","headerLayout"]}
                  label="Logo and info to the center"
                  fieldValue="centered-logo"
                  icon="hlogo-center"
                />
                <IconRadioBox
                  tabIndex={1}
                  form={form}
                  path={["layout","headerLayout"]}
                  label="Logo to the right and info to the left"
                  fieldValue="right-aligned-logo"
                  icon="hlogo-right"
                />
              </SplitColumnsContainer>
            </Field>

            <SplitColumnsContainer>
                <Field label="Footer on last page:">
                  <div className="radio-list">
                    <SimpleRadiobox
                      form={form}
                      path={["layout","lastPageFooter"]}
                      fieldValue={true}
                      label="Display footer on last page"
                    />
                    <SimpleRadiobox
                      form={form}
                      path={["layout","lastPageFooter"]}
                      fieldValue={false}
                      label="Do not display footer"
                    />
                  </div>
                </Field>
                <Field label="Paper size:">
                  <div className="radio-list">
                    <SimpleRadiobox
                      form={form}
                      path={["layout","paperSize"]}
                      fieldValue={[8.5, 11]}
                      stringifyValue={stringifyPaperSize}
                      label="US-Letter (8.5 x 11.0 in)"
                    />
                    <SimpleRadiobox
                      form={form}
                      path={["layout","paperSize"]}
                      fieldValue={[8.27, 11.69]}
                      stringifyValue={stringifyPaperSize}
                      label="A4 (8.27 x 11.69 in)"
                    />
                  </div>
                </Field>
            </SplitColumnsContainer>
            <SplitColumnsContainer>
              <Combobox
                label="Report language:"
                form={form}
                path={["layout",'language']}
                options={Object.keys(languageOptions)}
                getLabel={(key) => languageOptions[key]}
                tabIndex={1}
                fieldClassName="languages-menu"
              />
              <Combobox
                label="Date format:"
                form={form}
                path={["layout",'dateFormat']}
                options={Object.keys(dateFormatOptions)}
                getLabel={(key) => dateFormatOptions[key]}
                tabIndex={1}
              />
            </SplitColumnsContainer>

            <Errors form={form}/>
          </Dialog.Content> :
          <Dialog.Content>

            <Field label="Institution logo:" descText="Click below or drag and drop your image file into the box to upload it. (PNG or JPG)">
            <ImageUpload
              uploadFetcher={uploadFetcher}
              form={form}
              getResource={getResource}
              path={["organization",'logo']}
              label="image"
              boxText="Click or drag and drop your image file here"
            />
            </Field>
            <SplitColumnsContainer>
              <TextInput
                form={form}
                path={["organization","organizationName"]}
                label='Name:'
                placeholder="Ex: Family Health"
              />
              <TextInput
                form={form}
                path={["organization","email"]}
                label='E-mail:'
                placeholder="Ex: example@email.com"
              />
            </SplitColumnsContainer>
            <SplitColumnsContainer>
              <TextInput
                form={form}
                path={["organization","phoneNumber"]}
                label='Phone number:'
                placeholder="(+11) 123-456-789"
              />
              <TextInput
                form={form}
                path={["organization","faxNumber"]}
                label='Fax number:'
                placeholder="(+11) 987-654-321"
              />
            </SplitColumnsContainer>
            <TextInput
              form={form}
              path={["organization","address"]}
              label='Address:'
              placeholder="Ex: Sesame Street, 60 - Harlem"
            />
            <SplitColumnsContainer>
              <TextInput
                form={form}
                path={["organization","zipCode"]}
                label='Zip code:'
                placeholder="Ex: 10026"
              />
              <TextInput
                form={form}
                path={["organization","city"]}
                label='City:'
                placeholder="Ex: New York"
              />
            </SplitColumnsContainer>
            <SplitColumnsContainer>
              <TextInput
                form={form}
                path={["organization","state"]}
                label='State:'
                placeholder="Ex: New York"
              />
              <TextInput
                form={form}
                path={["organization","country"]}
                label='Country:'
                placeholder="Ex: USA"
              />
            </SplitColumnsContainer>
            <Errors form={form}/>
          </Dialog.Content>
        }
        <Dialog.Footer>
          <Form form={form} onSuccess={closeDialog}>
            <Button onClick={closeDialog}>Cancel</Button>
            <Button highlight isLoading={form.isLoading} type="submit">Save</Button>
          </Form>
        </Dialog.Footer>
        {children}
      </Dialog>
    )
  }
}



// WEBPACK FOOTER //
// ./~/report-components/src/modules/editor/Header.js